export type Language = 'sr' | 'en';

export const locales: Language[] = ['en', 'sr'];

type RouteTranslations = {
    [route: string]: Record<Language, string>
};

const routesTranslations: RouteTranslations = {
    '/news': {
        sr: "/vesti",
        en: "/news"
    },
    '/news/:seo_slug': {
        sr: "/vesti/:seo_slug",
        en: "/news/:seo_slug",
    },
    '/news/:id/:seo_slug': {
        sr: "/vesti/:id/:seo_slug",
        en: "/news/:id/:seo_slug",
    },
    '/products': {
        sr: "/proizvodi",
        en: "/products",
    },
    '/products/:id': {
        sr: "/proizvodi/:id",
        en: "/products/:id",
    },
    "/products/:id/:seo_slug": {
        sr: "/proizvodi/:id/:seo_slug",
        en: "/products/:id/:seo_slug",
    },
    "/preview/:entity/:id": {
        sr: "/preview/:entity/:id",
        en: "/preview/:entity/:id",
    },
    '/categories': {
        sr: "/kategorije",
        en: "/categories",
    },
    '/categories/:id': {
        sr: "/kategorije/:id",
        en: "/categories/:id",
    },
    "/shop/checkout": {
        sr: "/prodavnica/odjava",
        en: "/shop/checkout",
    },

    "/ws/cart": {
        sr: "/ws/korpa",
        en: "/ws/cart"
    },
    "/ws/checkout": {
        sr: "/ws/checkout",
        en: "/ws/checkout"
    },
    // thank-you page
    "/ws/order/:id/:status":{
        sr: "/ws/narudzbina/:id/:status",
        en: "/ws/order/:id/:status",
    },

    "/profile": {
        sr: "/profil",
        en: "/profile",
    },
    "/profile/orders": {
        sr: "/profil/narudzbine",
        en: "/profile/orders",
    },
    "/profile/orders/:id": {
        sr: "/profil/narudzbine/:id",
        en: "/profile/orders/:id",
    },
    "/profile/wishlist": {
        sr: "/profil/lista-zelja",
        en: "/profile/wishlist",
    },
    "/profile/points": {
        sr: "/profil/bodovi",
        en: "/profile/points",
    },
    "/profile/newsletter": {
        sr: "/profil/pretplata",
        en: "/profile/newsletter"
    },
    "/profile/reset-password": {
        sr: "/profil/promena-lozinke",
        en: "/profile/reset-password"
    },
    "/profile/reset-password/:token": {
        sr: "/profil/promena-lozinke/:token",
        en: "/profile/reset-password/:token"
    }
}

interface Rewrites {
    beforeFiles: { source: string; destination: string; locale: boolean }[];
}

export const rewrites = async (): Promise<any> => {
    const beforeFiles = [];
  
    for (const route in routesTranslations) {
      for (const lang in routesTranslations[route]) {
        const translatedRoute = routesTranslations[route][lang as keyof typeof routesTranslations[string]];
        const sourceRoute = '/' + lang + translatedRoute;
        const destinationRoute = '/' + lang + route;
  
        beforeFiles.push({
          source: sourceRoute,
          destination: destinationRoute,
          locale: false
        });
      }
    }
  
    return {beforeFiles};
};
  
export { routesTranslations };